import { render, staticRenderFns } from "./ExpandInfo.vue?vue&type=template&id=1590bd17"
import script from "./ExpandInfo.vue?vue&type=script&lang=js"
export * from "./ExpandInfo.vue?vue&type=script&lang=js"
import style0 from "./ExpandInfo.vue?vue&type=style&index=0&id=1590bd17&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports